import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DeepLinkRedirect = () => {
  const location = useLocation();
  const fullPath = location.pathname.replace('/DeeplinkRedirect/', '');

  useEffect(() => {
    const appDeepLink = `a12://${fullPath}`;
    window.location.href = appDeepLink;

    // Detectar o sistema operacional
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    // Redireciona para a loja correta se o app não abrir em 2 segundos
    setTimeout(() => {
      if (isIOS) {
        window.location.href = "https://apps.apple.com/us/app/aparecida/id1535032788";
      } else if (isAndroid) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.a12&hl=pt_BR";
      }
    }, 2000);
  }, []);

  return <p></p>;
};

export default DeepLinkRedirect;
